var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"game-91rushgames-link",attrs:{"href":_vm.getHref}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }